import { Component, signal } from '@angular/core';

@Component({
  selector: 'app-premium',
  imports: [],
  templateUrl: './premium.component.html',
  styleUrl: './premium.component.scss'
})
export class PremiumComponent {
  isModalOpen = signal(false);
selectedUser = signal<any>(null);

openModal(user: any) {
    this.selectedUser.set(user);
    this.isModalOpen.set(true);
}

closeModal() {
    this.isModalOpen.set(false);
}

}
